module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "kbx-welcome",
    attrs: {
      "klickbox-edit-item": "general",
      "klickbox-edit-label": _vm.$t('edit.canvas.general_styles')
    }
  }, [_c('div', {
    staticClass: "kbx-content"
  }, [_c('description'), _vm._v(" "), _c('title-preview'), _vm._v(" "), _c('buttons')], 1)])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-30b02d59!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/welcome/Main.vue
 ** module id = 792
 ** module chunks = 1
 **/